// firebase.ts

import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyB3axmDin49EBIoC_T5wodh61fudqcSDbs",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "prepexam-7ff8a.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "prepexam-7ff8a",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "prepexam-7ff8a.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "197070229556",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:197070229556:web:52399ada0367818905fa61",
};

// const app = initializeApp(firebaseConfig);
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
// export const googleProvider = new GoogleAuthProvider();
